import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bot, Loader2, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { forgotPassword, formatApiError } from "@/lib/api";
import { COPYRIGHT } from "@/lib/legalTexts";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative z-[1]">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="h-11 w-11 rounded-md bg-[var(--pos)] flex items-center justify-center">
            <Bot className="h-6 w-6 text-black" strokeWidth={2.4} />
          </div>
          <div>
            <div className="font-head font-black text-xl tracking-tight">CRYPTOSENSE</div>
            <div className="text-[10px] text-[var(--accent)] tracking-[0.25em]">AI TRADING DESK</div>
          </div>
        </div>

        <div className="rounded-xl border border-[var(--border)] bg-[var(--surface)] p-7">
          {sent ? (
            <div className="text-center space-y-4 py-4" data-testid="forgot-success">
              <CheckCircle2 className="h-12 w-12 text-[var(--pos)] mx-auto" />
              <h1 className="font-head font-bold text-xl">E-posta Gönderildi</h1>
              <p className="text-sm text-[var(--text-dim)]">
                Eğer bu e-posta kayıtlıysa, şifre sıfırlama bağlantısı gönderildi. Gelen kutunuzu (ve spam klasörünü) kontrol edin.
              </p>
              <Button data-testid="back-to-login" onClick={() => nav("/login")}
                className="w-full h-11 bg-[var(--pos)] text-black font-bold hover:bg-[var(--pos-hover)] hover:text-black">
                Giriş Ekranına Dön
              </Button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <div>
                <h1 className="font-head font-bold text-2xl">Şifremi Unuttum</h1>
                <p className="text-sm text-[var(--text-dim)] mt-1">Sıfırlama bağlantısı için e-postanızı girin</p>
              </div>
              <div>
                <Label className="text-xs text-[var(--text-dim)]">E-posta</Label>
                <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                  className="mt-1 bg-[var(--app-bg)] border-[var(--border)] font-mono text-sm h-11" />
              </div>
              <Button data-testid="forgot-submit" type="submit" disabled={busy}
                className="w-full h-12 bg-[var(--pos)] text-black font-bold hover:bg-[var(--pos-hover)] hover:text-black">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Mail className="h-4 w-4 mr-1.5" /> Sıfırlama Bağlantısı Gönder</>}
              </Button>
              <button type="button" onClick={() => nav("/login")}
                className="w-full flex items-center justify-center gap-1 text-xs text-[var(--text-faint)] hover:text-[var(--text-primary)]">
                <ArrowLeft className="h-3 w-3" /> Girişe dön
              </button>
            </form>
          )}
        </div>
        <p className="mt-6 text-center text-[10px] text-[var(--text-faint)] font-mono">{COPYRIGHT}</p>
      </div>
    </div>
  );
}
